import React from "react";
import { withRouter } from "react-router-dom";
import Contentify from "../../../content/Contentify";
import Button from "./Button";
import { Paths } from "../../../constants/UrlConstants";
import Store from "../../../content/Store";

export const MakeAClaimButton = ({ content, history }) => (
  <Button
    label={content.label}
    buttonType="primaryOrangeButton"
    onClick={() => {
      history.push(Paths.MakeAClaim);
    }}
  />
);

MakeAClaimButton.content = Store.MakeAClaimButton;

export default withRouter(Contentify(MakeAClaimButton));